import createAction from '@clearscore/helpers.create-action';
import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore/helpers.resolve-request';

import createReducers from './reducers';
import { getTypes } from './types';

const snakify = (input) =>
    input
        .split(/(?=[A-Z])/)
        .join('_')
        .toUpperCase();

const createActionSelector = (moduleName, type) =>
    createSelector(
        (state) => resolveRequest(state, `${moduleName}.${type}`),
        (result) => result,
    );
const createStatusSelector = (moduleName, type) =>
    createSelector(createActionSelector(moduleName, type), ({ status, statusCode }) =>
        getRequestStatus(status, statusCode),
    );

export default ({ moduleName, actionCreators, customReducer }) => {
    const createActionType = (prev = {}, actionName) => ({
        ...prev,
        [actionName]: `CS/${snakify(moduleName)}_${snakify(actionName)}`,
    });
    const createType = (prev, actionName, actionTypes) => ({
        ...prev,
        [actionName]: getTypes(actionTypes[actionName]),
    });
    const createActions = (prev, actionName, types) => ({
        ...prev,
        [actionName]: actionCreators[actionName](types[actionName].pending),
        [`${actionName}Reset`]: (payload) => createAction(types[actionName].reset, payload),
    });
    const createSelectors = (prev, actionName) => ({
        ...prev,
        [actionName]: {
            getState: createActionSelector(moduleName, actionName),
            getStatus: createStatusSelector(moduleName, actionName),
        },
    });

    const { types, actions, selectors, actionTypes } = Object.keys(actionCreators).reduce((prev, actionName) => {
        const newActionTypes = createActionType(prev.actionTypes, actionName);
        const newType = createType(prev.types, actionName, newActionTypes);
        const newActions = createActions(prev.actions, actionName, newType);
        const newSelectors = createSelectors(prev.selectors, actionName);
        return {
            ...prev,
            actionTypes: newActionTypes,
            types: newType,
            actions: newActions,
            selectors: newSelectors,
        };
    }, {});

    return {
        reducers: {
            domain: createReducers(actionTypes, customReducer),
        },
        types,
        actionTypes,
        actions,
        selectors,
    };
};
